import { render, staticRenderFns } from "./bidComplaint.vue?vue&type=template&id=6628bea6&scoped=true"
import script from "./bidComplaint.vue?vue&type=script&lang=js"
export * from "./bidComplaint.vue?vue&type=script&lang=js"
import style0 from "./bidComplaint.vue?vue&type=style&index=0&id=6628bea6&prod&lang=less&scoped=true"
import style1 from "./bidComplaint.vue?vue&type=style&index=1&id=6628bea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628bea6",
  null
  
)

export default component.exports